import { styled } from '@mui/material';
import { css } from '@emotion/react';
import { marginRight } from 'utils';

export const StyledNotificationContainer = styled('div')(
  ({ theme, isRead }) => css`
    background-color: #cafdf5;
    border: 1px solid ${theme.palette.primary.main};
    border-radius: 8px;
    padding: 8px 12px;

    .icon {
      color: ${theme.palette.primary.darker};
    }

    .notification-header {
      display: flex;
      gap: 20px;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    .bullet {
      width: 6px;
      height: 6px;
      background: ${theme.palette.annotation.error};
      box-sizing: border-box;
      border-radius: 11px;
    }

    .title {
      font-size: ${theme.typography.caption.fontSize};
      font-weight: ${theme.typography.caption.fontWeight};
      line-height: 24px;
      color: ${theme.palette.primary.darkest};
    }

    .date-time {
      color: #777777;
      font-size: ${theme.typography.overline.fontSize};
    }

    .description {
      color: ${theme.palette.gray.darker};
      font-size: ${theme.typography.caption.fontSize};
      font-weight: ${theme.typography.caption.fontWeight};
      line-height: 24px;
      margin: 0;

      ${!isRead &&
      css`
        ${marginRight('18px')}
      `}
    }
  `
);
